export default __webpack_public_path__ + "static/media/saladereuniones.9bd8465a.svg";